import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {ReportDetailsComponent} from '../report-details/report-details.component';
import {environment} from '../../../../../../environments/environment';
import {CommonService} from '../../../../../_services/common.service';
import {PreviewImageComponent} from '../../../../../components/preview-image/preview-image.component';
import {LocalStorageService} from '../../../../../_services';

@Component({
  selector: 'app-why-report-card',
  templateUrl: './report-card.component.html',
  styleUrls: ['./report-card.component.scss']
})
export class ReportCardComponent implements OnInit, AfterViewInit, AfterViewChecked {

  @Input() eventType = '';
  @Input() detailReportType = false;
  @Input() addDeleteOption = false;
  @Output() viewReport: EventEmitter<any> = new EventEmitter<any>();
  @Output() addReport: EventEmitter<any> = new EventEmitter<any>();
  @Output() deleteReportEvent: EventEmitter<any> = new EventEmitter<any>();
  report: any;
  serverUrl = environment.server + '/public';
  projectType: any;
  isAdmin = false;

  constructor(public modalController: ModalController,
              private commonService: CommonService,
              private localStorageService: LocalStorageService,
              private cdr: ChangeDetectorRef) {
    const currentUser = this.localStorageService.get(environment.currentUser);
    if (currentUser) {
      this.isAdmin = currentUser.user.isAdmin;
    }
  }

  @Input() set reportObj(value: any) {
    this.report = value;
    if (value && value.emotions && value.emotions.length > 3) {
      const countObj = value.emotions.reduce((cnt, cur) => (cnt[cur] = cnt[cur] + 1 || 1, cnt), {});
      this.report.emotions = Object.keys(countObj).sort((a, b) => countObj[a] - countObj[b]);
    }
    if (this.report && this.report.projectType) {
      [this.projectType, this.report.projectImg] = this.commonService.getProjectLogo(this.report.projectType);
    }
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  async reportDetails(report?: any) {
    report.viewReport = false;
    const modal = await this.modalController.create({
      component: ReportDetailsComponent,
      componentProps: {
        report
      },
      cssClass: 'custom-modal to-left',
      showBackdrop: true,
      backdropDismiss: true,
    });
    return await modal.present();
  }

  addNewReport(report: any) {
    this.addReport.emit();
    return false;
  }

  viewMyReport(report: any) {
    this.viewReport.emit(report);
  }

  async previewImage(image) {
    const modal = await this.modalController.create({
      component: PreviewImageComponent,
      componentProps: {
        image
      },
      cssClass: 'custom-modal',
      showBackdrop: true,
      backdropDismiss: true
    });
    return await modal.present();
  }

  deleteReport() {
    event.stopPropagation();
    this.deleteReportEvent.emit();
    return false;
  }
}
